import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { authAPI } from "@/lib/api";
import { ENDERECO_DA_PLATAFORMA, entradaComVolta, semCadastroNoMemoire } from "@/lib/sessao-unica";

/*
  Onde ficava o formulário de senha quando o login é único.

  Não é uma tela de login disfarçada: ela não pede nada e não guarda nada. Só
  leva para o único lugar onde se entra. O formulário de verdade continua no
  código porque `francesnativo.com/memoire` roda o mesmo pacote e ainda o usa —
  o que muda entre os dois é uma variável de ambiente.

  `replace` e não `href`: quem voltar no navegador deve sair daqui, e não cair
  de novo nesta tela, que o mandaria adiante outra vez. Um botão "voltar" que
  não volta é defeito.
*/
const MandaParaAPlataforma = () => {
  const semCadastro = semCadastroNoMemoire();
  /*
    Já autenticado não sai daqui.

    `/` manda para `/login`, e com login único `/login` é esta tela. Sem esta
    checagem, quem chegasse em `memoire.uninativ.com` **já logado** seria
    expulso para a plataforma — o contrário do que o login único promete.
  */
  const usuario = authAPI.getCurrentUser();

  useEffect(() => {
    /* Quem entrou na plataforma e não tem Mémoire fica. Mandá-lo de volta o
       traria para cá outra vez, e ele giraria entre os dois sem nunca ler o
       motivo. */
    if (semCadastro || usuario) return;
    window.location.replace(entradaComVolta());
  }, [semCadastro, usuario]);

  if (usuario) {
    const daEquipe = usuario.tipo_usuario === "admin" || usuario.tipo_usuario === "professor";
    return <Navigate to={daEquipe ? "/admin" : "/aluno"} replace />;
  }

  if (semCadastro) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#013079] to-[#1a4a9e] p-4">
        <div className="text-center text-white space-y-4 max-w-md">
          <p className="text-lg">Sua conta não inclui o Mémoire.</p>
          <p className="text-sm text-white/70">
            Ele é vendido à parte do curso. Se você acha que deveria ter acesso,
            fale com o professor.
          </p>
          <a
            href={ENDERECO_DA_PLATAFORMA}
            className="inline-block text-sm underline text-white/90 hover:text-white"
          >
            Voltar para o curso
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#013079] to-[#1a4a9e] p-4">
      <div className="text-center text-white space-y-4">
        <Loader2 className="w-8 h-8 mx-auto animate-spin" />
        <p className="text-lg">Levando você para a entrada…</p>
        <p className="text-sm text-white/70">
          O acesso ao Mémoire agora é pelo mesmo lugar do curso.
        </p>
        <a
          href={ENDERECO_DA_PLATAFORMA}
          className="inline-block text-sm underline text-white/90 hover:text-white"
        >
          Se nada acontecer, clique aqui.
        </a>
      </div>
    </div>
  );
};

export default MandaParaAPlataforma;
